import Utility from '../../../../../../util/utilityfunctions';

import {config as yesNoOverdueColumn} from '../../common/YesNoOverdueColumn';

export const prop = 'partInv';
export const id = 'partnerInvitedColumn';

export const config = (labels) =>
	yesNoOverdueColumn({
		fullId: id,
		label: labels.partnerInvited,
		prop,
		width: 'minmax(var(--px-140), 2fr)',
		isOverdue: (item) => !!Utility.yeardateIsOverdue(item.relDate) && !item[prop]
	});
